"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContext = void 0;
const react_1 = require("react");
exports.ModalContext = (0, react_1.createContext)(null);
